<script>
	import Engage from "./Engage.svelte";
	import heartOutline from "@iconify/icons-ci/heart-outline";
	import heartFill from "@iconify/icons-ci/heart-fill";
	import shareForwardFill from "@iconify/icons-ri/share-forward-fill";
	import shareForwardLine from "@iconify/icons-ri/share-forward-line";
	import barChart from "@iconify/icons-bi/bar-chart";
	import barChartFill from "@iconify/icons-bi/bar-chart-fill";
	import outlineBookmarkBorder from "@iconify/icons-ic/outline-bookmark-border";
	import baselineBookmarkAdded from "@iconify/icons-ic/baseline-bookmark-added";
	import upvoteLine from '@iconify/icons-bx/upvote';
	import upvoteFill from '@iconify/icons-bxs/upvote';
	import downvoteLine from '@iconify/icons-bx/downvote';
	import downvoteFill from '@iconify/icons-bxs/downvote';
	import { engageButtons } from "./stores.js";
	
	export let stim;
	export let idx;

</script>

<section class="engagement">
	{#each $engageButtons as eb}
		{#if eb == "shares"}
			<Engage
				icon={shareForwardLine}
				iconClicked={shareForwardFill}
				engageType={eb}
				entity_id={stim.entity_id}
				entity_url={stim.entity_url}
				engageValue={stim[eb]}
				tooltiptitle="Share"
				{idx}
			/>
		{/if}
		{#if eb == "likes"}
			<Engage
				icon={heartOutline}
				iconClicked={heartFill}
				engageType={eb}
				entity_id={stim.entity_id}
				entity_url={stim.entity_url}
				engageValue={stim[eb]}
				tooltiptitle="Like"
				{idx}
			/>
		{/if}
		{#if eb == "read_later"}
			<Engage
				icon={outlineBookmarkBorder}
				iconClicked={baselineBookmarkAdded}
				engageType={eb}
				entity_id={stim.entity_id}
				entity_url={stim.entity_url}
				engageValue={stim[eb]}
				tooltiptitle="Read later"
				{idx}
			/>
		{/if}
		{#if eb == "accuracy_score"}
			<Engage
				icon={barChart}
				iconClicked={barChartFill}
				engageType={eb}
				entity_id={stim.entity_id}
				entity_url={stim.entity_url}
				engageValue={stim[eb]}
				tooltiptitle="Accuracy score"
				{idx}
			/>
		{/if}
		{#if eb == "upvote"}
			<Engage
				icon={upvoteLine}
				iconClicked={upvoteFill}
				engageType={eb}
				entity_id={stim.entity_id}
				entity_url={stim.entity_url}
				engageValue={stim[eb]}
				tooltiptitle="Upvote"
				{idx}
			/>
		{/if}
		{#if eb == "downvote"}
			<Engage
				icon={downvoteLine}
				iconClicked={downvoteFill}
				engageType={eb}
				entity_id={stim.entity_id}
				entity_url={stim.entity_url}
				engageValue={stim[eb]}
				tooltiptitle="Downvote"
				{idx}
			/>
		{/if}
	{/each}
</section>

<style>
	.engagement {
		margin: 8px;
		text-align: center;
	}
</style>
